import { Howl } from 'howler';

const SOUND_ENABLED_KEY = 'colobongo_sound_enabled';

const SOUND_PATHS = {
  enter: '/sounds/BruitEntrerAppli.mp3',
  click: '/sounds/ClickofficielGrave.mp3',
  save: '/sounds/PopPhoto.mp3',
  complete: '/sounds/Défi_RéalisteCute.mp3',
};

const SOUND_CONFIG = {
  enter: { volume: 0.5 },
  click: { volume: 0.3 },
  save: { volume: 0.4 },
  complete: { volume: 0.5 },
};

const soundInstances = {};

function isBrowser() {
  return typeof window !== 'undefined';
}

function getSoundInstance(soundName) {
  if (!SOUND_PATHS[soundName]) return null;
  if (soundInstances[soundName]) return soundInstances[soundName];

  const config = SOUND_CONFIG[soundName] || { volume: 0.4 };
  soundInstances[soundName] = new Howl({
    src: [SOUND_PATHS[soundName]],
    volume: config.volume,
    preload: true,
  });
  return soundInstances[soundName];
}

export function isSoundEnabled() {
  if (!isBrowser()) return false;
  try {
    const stored = window.localStorage.getItem(SOUND_ENABLED_KEY);
    // Default: sounds ON (null means the user never changed the setting)
    return stored === null ? true : stored === 'true';
  } catch (_error) {
    return true;
  }
}

export function setSoundEnabled(enabled) {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(SOUND_ENABLED_KEY, enabled ? 'true' : 'false');
  } catch (_error) {
    // best effort persistence
  }
}

export function playSound(soundName) {
  if (!isBrowser()) return;
  if (!isSoundEnabled()) return;

  const instance = getSoundInstance(soundName);
  if (!instance) return;

  try {
    instance.play();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[SOUND] Failed to play sound', { soundName, error: error?.message || 'unknown' });
  }
}

export const SOUNDS = {
  ENTER: 'enter',
  CLICK: 'click',
  SAVE: 'save',
  COMPLETE: 'complete',
};

export default {
  playSound,
  isSoundEnabled,
  setSoundEnabled,
  SOUNDS,
};
